<template>
  <div id="gallery" class="gallery">
    
    <!-- Gallery modal -->
    <div v-if="modalImageIndex !== null" v-on:click.self="modalImageIndex = null" class="gallery-modal-bg">      
      <img
        v-on:load="handleLoad"
        v-on:error="handleError"
        v-if="photos && photos[modalImageIndex]"
        class="modal-selected-image"
        alt="activity-image"
        :src="photos[modalImageIndex].originalUrl" />
      <div class="navigation-button-container">
        <div class="previous-btn" v-on:click="setImageIndex(modalImageIndex - 1)">
          <img style="flex: 1;" class="arrow-nav" alt="left-arrow" :src="require('../assets/arrow-left.png')" />
        </div>
        <div class="next-btn" v-on:click="setImageIndex(modalImageIndex + 1)">
          <img style="flex: 1;" class="arrow-nav" alt="right-arrow" :src="require('../assets/arrow-right.png')" />
        </div>
      </div>
      <div class="close-btn" v-on:click="modalImageIndex = null">
        <img style="flex: 1;" class="close-icon" alt="close" :src="require('../assets/close.png')" />
      </div>
    </div>

    <!-- When 1 picture --> 
    <div v-if="photos && photos.length === 1" class="1-img container">
      <div v-on:click="modalImageIndex = 0" class="image-container">
        <img
        v-on:load="handleLoad"
        v-on:error="handleError"
        class="image"
        alt="activity-image"
        :src="getImageByIndex(0)" />
      </div>
    </div>

    <!-- When 2 pictures -->
    <div v-if="photos && photos.length === 2" class="1-img container">
      <div v-on:click="modalImageIndex = 0" class="image-container">
        <img
          v-on:load="handleLoad"
          v-on:error="handleError"
          class="image"
          alt="activity-image"
          :src="getImageByIndex(0)" />
      </div>
      <div v-on:click="modalImageIndex = 1" class="image-container">
        <img
          v-on:load="handleLoad"
          v-on:error="handleError"
          class="image"
          alt="activity-image"
          :src="getImageByIndex(1)" />
      </div>
    </div>

    <!-- When 3 pictures -->
    <div v-if="photos && photos.length === 3" class="1-img container">
      <div v-on:click="modalImageIndex = 0" class="image-container">
        <img
          v-on:load="handleLoad"
          v-on:error="handleError"
          class="image"
          alt="activity-image"
          :src="getImageByIndex(0)" />
      </div>
      <div class="column">
        <div v-on:click="modalImageIndex = 1" class="image-container">
          <img
            v-on:load="handleLoad"
            v-on:error="handleError"
            class="image"
            alt="activity-image"
            :src="getImageByIndex(1)" />
        </div>
        <div v-on:click="modalImageIndex = 2" class="image-container">
          <img
            v-on:load="handleLoad"
            v-on:error="handleError"
            class="image"
            alt="activity-image"
            :src="getImageByIndex(2)" />
        </div>
      </div>
    </div>

    <!-- When 4 pictures -->
    <div v-if="photos && photos.length === 4" class="1-img container">
      <div v-on:click="modalImageIndex = 0" class="image-container">
        <img
          v-on:load="handleLoad"
          v-on:error="handleError"
          class="image"
          alt="activity-image"
          :src="getImageByIndex(0)" />
      </div>
      <div class="column">
        <div class="row">
          <div v-on:click="modalImageIndex = 1" style="height: 225px; max-height: 25vh;" class="image-container">
            <img
              v-on:load="handleLoad"
              v-on:error="handleError"
              style="height: 225px; max-height: 25vh;"
              class="image"
              alt="activity-image"
              :src="getImageByIndex(1)" />
          </div>        
          <div v-on:click="modalImageIndex = 3" style="height: 225px; max-height: 25vh;" class="image-container">
            <img
              v-on:load="handleLoad"
              v-on:error="handleError"
              style="height: 225px; max-height: 25vh;"
              class="image"
              alt="activity-image"
              :src="getImageByIndex(3)" />
          </div>
        </div>
        <div v-on:click="modalImageIndex = 2" style="height: 225px; max-height: 25vh;" class="image-container">
          <img
            v-on:load="handleLoad"
            v-on:error="handleError"
            class="image"
            alt="activity-image"
            :src="getImageByIndex(2)" />
        </div>   
      </div>
    </div>

    <!-- When 5 pictures -->
    <div v-if="photos && photos.length > 4" class="1-img container">
      <div v-on:click="modalImageIndex = 0" class="image-container">
        <img
          v-on:load="handleLoad"
          v-on:error="handleError"
          class="image"
          alt="activity-image"
          :src="getImageByIndex(0)" />
      </div>
      <div class="column">
        <div class="row">
          <div v-on:click="modalImageIndex = 1" style="height: 225px; max-height: 25vh;" class="image-container">
            <img
              v-on:load="handleLoad"
              v-on:error="handleError"
              style="height: 225px; max-height: 25vh;"
              class="image"
              alt="activity-image"
              :src="getImageByIndex(1)" />
          </div>        
          <div v-on:click="modalImageIndex = 3" style="height: 225px; max-height: 25vh;" class="image-container">
            <img
              v-on:load="handleLoad"
              v-on:error="handleError"
              style="height: 225px; max-height: 25vh;"
              class="image"
              alt="activity-image"
              :src="getImageByIndex(3)" />
          </div>
        </div>
        <div class="row">
          <div v-on:click="modalImageIndex = 2" style="height: 225px; max-height: 25vh;" class="image-container">
            <img
              v-on:load="handleLoad"
              v-on:error="handleError"
              style="height: 225px; max-height: 25vh;"
              class="image"
              alt="activity-image"
              :src="getImageByIndex(2)" />
          </div>        
          <div v-on:click="modalImageIndex = 4" style="height: 225px; max-height: 25vh;" class="image-container">
            <img
            v-on:load="handleLoad"
            v-on:error="handleError"
            style="height: 225px; max-height: 25vh;"
            class="image"
            alt="activity-image"
            :src="getImageByIndex(4)" />
          </div>
        </div> 
      </div>
    </div>

    <div class="view-photos" v-on:click="modalImageIndex = 0">
      {{ getTranslation('VIEW_PHOTOS') }}
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'Gallery',
  props: {
    photos: Array,
    getTranslation: Function
  },
   data: function () {
    return {
      modalImageIndex: null,
      loadedImageAmount: 0
    }
  },
  methods: {
    setImageIndex: function (index) {
      this.modalImageIndex = (index + this.photos.length) % this.photos.length
    },
    handleLoad: function () {
      this.loadedImageAmount += 1
      if (this.loadedImageAmount === this.photos.length || this.loadedImageAmount > 4) {
        // do something after images have been load
        this.$emit('imagesloaded')
      }
    },
    handleError: function () {
      this.loadedImageAmount += 1
      if (this.loadedImageAmount === this.photos.length || this.loadedImageAmount > 4) {
        // do something after images have been load
        this.$emit('imagesloaded')
      }
    },
    getImageByIndex: function (index) {
      if (this.photos && this.photos[index] && this.photos[index].derived && this.photos[index].derived.length > 0) {
        const derived = this.photos[index].derived
        const largeImg = derived.filter(_ => _.name === 'large')[0]        
        return (largeImg && largeImg.url) || this.photos[index].originalUrl
      }
      return this.photos && this.photos[index] && this.photos[index].originalUrl
    }
  },
  mounted: function () {
    // Backup if too much delay loading the images
    setTimeout(() => {
      this.$emit('imagesloaded')
    }, 2000)
  }
}
</script>

<style>
.view-photos {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 15px;
  background-color: white;
}
.view-photos:hover {
  opacity: 0.6;
}
.navigation-button-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  max-width: 400px;
  margin: auto;
}
.gallery {
  animation-name: fade-in;
  animation-duration: 1s;
  position: relative;
}
.container {
  display: flex;
  max-width: 100vw;
  max-height: 50vh;
  height: 450px;
  flex-direction: row;
}
.image-container {
  flex: 1;
  min-height: 0px;
}
.image {
  height: 100%;
  width: 100%;
  object-fit: cover;
  transition: 0.2s opacity;
}
.image:hover {
  opacity: 0.9;
}
.column {
  flex: 1;
  flex-direction: column;
  display: flex;
}
.row {
  flex: 1;
  flex-direction: row;
  display: flex;
}
.gallery-modal {
  
}
.gallery-modal-bg {
  background-color: rgba(0,0,0,0.9);
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 1;
  text-align: center;
}
.modal-selected-image {
  height: 50%;
  max-height: 70vh;
  width: 1000px;
  max-width: 100vw;
  object-fit: contain;
  z-index: 2;
  margin: auto;
  margin-top: 20vh;
}
.main-image-container {
  max-width: 1000px;
  max-height: 600px;
  
}
.previous-btn {
  background-color: white;
  flex: 1;
  padding: 15px;
  margin: 5px;
  user-select: none;
  border-radius: 2px;
  max-width: 30vw;
}
.next-btn {
  background-color: white;
  flex: 1;
  padding: 15px;
  margin: 5px;
  user-select: none;
  border-radius: 2px;
  max-width: 30vw;
}
.close-icon {
  height: 25px;
  width: 25px;
  padding: 15px;
  padding-top: 5px;
}
.close-btn {
  color: red;
  padding: 20px;
  padding-top: 10px;
  user-select: none;
  max-width: 100px;
  margin: auto;
}
.next-btn:hover {
  opacity: 0.9;
}
.arrow-nav {
  height: 20px;
  object-fit: contain;
}
.previous-btn:hover {
  opacity: 0.9;
}
.close-btn:hover {
  opacity: 0.4;
}
</style>
